import { css } from 'styled-components';

const styles = css`
  .tabs {
    font-family: arial;
    width: 100%;
    background-color: ${(props) => props.theme.colorPalette.white};
    padding: 24px 0 0 0;
    border-radius: 10px;
    margin: 20px 0px;
  }

  img {
    width: 300px;
  }

  .tab-buttons {
    border-bottom: 1px solid ${(props) => props.theme.colorPalette.gray[200]};
    margin-left: 18px;
    margin-right: 18px;
    margin-bottom: 10px;
  }

  .tab-btn {
    background: transparent;
    border: none;
    outline: none;
    padding: 5px 10px;
    cursor: pointer;
    transition: all ease-in-out 0.2s;
    color: black;
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
  }
  .tab-content {
    padding: 0px 10px;
    width: 80%;
    margin-left: 10%;
  }

  .active {
    border: none;
    margin-bottom: -2px;
    padding: 5px 10px;
    border-bottom: 3px solid ${(props) => props.theme.colorPalette.blue[500]};
    background: transparent;
    color: black;
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 29px;
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .tab-content {
      width: 100%;
      margin-left: 0%;
    }
    .tabs {
      font-family: arial;
      width: 100%;
      background-color: ${(props) => props.theme.colorPalette.white};
      padding: 24px 0 0 0;
      border-radius: 10px;
      margin: 20px 0px;
      min-height: 430px;
    }
    ${(props) =>
      props.isOutfitsOnBagEnabled
        ? `
    .tab-buttons {
      overflow: scroll hidden;
      white-space: nowrap;
      -ms-overflow-style: none;
      scrollbar-width: none;
      margin-right: 0;
      padding-right: 18px;
    }
    .tab-buttons::-webkit-scrollbar {
      display: none;
    }
    .active, .tab-btn {
      padding: 5px 0;
      margin-left: 18px;
    }
    .tab-buttons > button:first-child {
      margin-left: 0;
    }
    `
        : ''}
  }
`;

export default styles;
